import { FormattedMessage } from 'react-intl';
import { MailIcon, PhoneIcon } from '@synergy/theme-next';
import { PoolLink, useIsMobile } from '@synergy/components-next';
import { ReactElement } from 'react';

import { FooterColumn } from './footer-column';
import { FooterColumnItem } from './footer-column-item';
import { FooterColumnTitle } from './footer-column-title';
import { FooterContact } from '../../../models/footer-contact';

export const ContactInformation = ({ contact }: { contact: FooterContact }): ReactElement => {
    const isMobile = useIsMobile();

    return (
        <FooterColumn>
            {isMobile ? undefined : (
                <FooterColumnTitle>
                    <FormattedMessage id="app.footer.contact.headline" />
                </FooterColumnTitle>
            )}
            {contact.name && (
                <FooterColumnItem>
                    <strong>{contact.name}</strong>
                </FooterColumnItem>
            )}
            {contact.address && <FooterColumnItem>{contact.address}</FooterColumnItem>}
            {contact.phone && (
                <FooterColumnItem sx={{ height: 22 }}>
                    <PoolLink colorVariant="grey500" href={`tel:${contact.phone}`}>
                        <PhoneIcon />
                        {contact.phone}
                    </PoolLink>
                </FooterColumnItem>
            )}
            {contact.email && (
                <FooterColumnItem sx={{ height: 22 }}>
                    <PoolLink colorVariant="grey500" href={`mailto:${contact.email}`}>
                        <MailIcon />
                        {contact.email}
                    </PoolLink>
                </FooterColumnItem>
            )}
        </FooterColumn>
    );
};
